import { yupResolver } from '@hookform/resolvers/yup';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import FormField from '@ingka/form-field';
import InputField from '@ingka/input-field';
import { prefix } from 'app';
import Button from '@ingka/button';
import { PosterApi } from '@loyaltypoint/ifapi-core';
import { useHistory } from 'react-router';

const validationSchema = yup.object().shape({
    password: yup
        .string()
        .required(),
});

export const LoginPage = () => {
    const { register, control, handleSubmit, watch, setError, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const setWithExpiry = (key, value, ttl) => {
        const now = new Date()
    
        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    }

    const posterApi = new PosterApi({
        basePath: process.env.REACT_APP_API_URL
      });
    let history = useHistory();

    const onSubmit = async (data) => {
        let tokenResponse = await posterApi.posterAuthorizePost(data.password); 
        
        setWithExpiry('login', tokenResponse.data.data, 1000 * 60 * 24 * 365 * 10);
        history.push("/");
    };

    React.useEffect(() => {
        if (errors.password)
            console.log(errors.password.message)
    })

    return (
        <div className="login">
            <form onSubmit={handleSubmit(onSubmit)}>
                <FormField valid={false} shouldValidate={errors.password}
                    // to nie
                    validation={errors.password && errors.password.message}
                >
                    <InputField
                        id={'password'} name={'password'}
                        type={'password'} label='Hasło'
                        {...register("password")}
                    />
                </FormField>
                <div>
                    {/* to się odpala */}
                    {errors.password && <span>{errors.password.message}</span>}
                </div>
                <Button prefix={prefix} text="Zaloguj się" type="primary" htmlType='submit' />
            </form>
        </div>
    )
}
